import React from 'react'

export default function ExampleTemplate2({ primaryColour, backgroundColour, textColour, headingFont, bodyFont, logo }) {
    return (
        <div
            style={{
                backgroundColor: '#eeeeed',
                borderRadius: '12px',
                height: '250px',
                overflow: 'scroll',
                display: 'flex',
                justifyContent: 'center',
                padding: '20px',
                paddingBottom: '0px'
            }}
        >
            <div style={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
                        <div>
                            <img
                                src={logo ? logo.url || logo.raw : ''}
                                style={{ width: '100%', maxWidth: '30px', maxHeight: '30px' }}
                            />
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <a style={{ color: primaryColour, fontSize: '7px' }}>View in Browser</a>
                        </div>
                    </div>
                    <div style={{ backgroundColor: backgroundColour, padding: '20px', paddingBottom: '0px' }}>
                        <div
                            style={{
                                fontSize: '8px',
                                fontWeight: 'bold',
                                marginBottom: '5px',
                                color: '#FFFFFF',
                                lineHeight: '10px',
                                fontFamily: headingFont
                            }}
                        >
                            Hey There! Welcome to a simpler CRM Experience.
                        </div>
                        <img
                            src='https://cdn1.ourmailsender.com/siteContent/brandAnalyzer/example2_img1.png'
                            style={{ width: '100%' }}
                        />
                    </div>

                    <div
                        style={{
                            fontSize: '8px',
                            padding: '20px',
                            lineHeight: '10px',
                            fontFamily: bodyFont,
                            color: textColour
                        }}
                    >
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.{' '}
                        <a style={{ color: primaryColour }}>Click Here</a>. Aenean auctor cursus eros vel suscipit. Ut
                        eleifend massa ac velit iaculis, nec convallis nisi rutrum. Fusce varius hendrerit arcu.
                    </div>
                </div>
            </div>
        </div>
    )
}
